// FavoritesContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { SERVER_URL } from "../constants.js";
import { toast } from "react-toastify";

const FavoritesContext = createContext();

export const useFavorites = () => {
  return useContext(FavoritesContext);
};

export const FavoritesProvider = ({ children }) => {
  const [favourites, setFavorites] = useState([]);
  const { isSignedIn } = useAuth();

  const { getToken } = useAuth();

  useEffect(() => {
    const getFavs = async () => {
      if (!isSignedIn) return;
  
      try {
        const token = await getToken();
        const response = await fetch(`${SERVER_URL}/api/v1/fav`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });
  
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  
        const result = await response.json();
        setFavorites(result.data || []);
      } catch (error) {
        console.error("Error fetching favorites:", error);
      }
    };
  
    getFavs();
  }, [isSignedIn]);
  

  const addToFavorites = async (item) => {
    try {
      if (!isSignedIn) {
        throw new Error("Please Sign In To Add To Favourites");
      }
      setFavorites((prevFavorites) => {
        if (!prevFavorites.some((fav) => fav._id === item._id)) {
          return [...prevFavorites, item];
        }
        return prevFavorites;
      });
      const token = await getToken();
      const response = await fetch(`${SERVER_URL}/api/v1/fav/add`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
  
        },
        body: JSON.stringify({ productId: item._id }),
      });
      const result = await response.json();
      if (!result.success) {
        if(result.statusCode == 401){
          throw new Error("Please Sign In To Add To Favorites");
        }
        throw new Error(result.message);
      }
      toast.success(result.message);
      
    } catch (error) {
      console.log(error);
      setFavorites((prevFavorites) => {
        return prevFavorites.filter((fav) => fav._id !== item._id);
      });
      toast.error(error.message || "Something Is Wrong. Please Try Again Later.");
    }
  };

  const removeFromFavorites = async (item) => {
    setFavorites((prevFavorites) => {
      return prevFavorites.filter((fav) => fav._id !== item._id);
    });
    try {
      const token = await getToken();
      const response = await fetch(`${SERVER_URL}/api/v1/fav/remove`, {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
   
        },
        body: JSON.stringify({ productId: item._id }),
      });
      const result = await response.json();
      if (!result.success) {
        throw new Error(result.message);
      }
      toast.success(result.message);
    } catch (error) {
      console.log(error);
      setFavorites((prevFavorites) => {
        if (!prevFavorites.some((fav) => fav._id === item._id)) {
          return [...prevFavorites, item];
        }
        return prevFavorites;
      });
      toast.error("Something Is Wrong. Please Try Again Later.");
    }
  };

  return (
    <FavoritesContext.Provider
      value={{ favourites, addToFavorites, removeFromFavorites }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};
